import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/site/Logo";
import { Footer } from "@/components/site/Footer";
import { PRIVACY, COOKIE } from "@/lib/legal";

const UPDATED = "12 ottobre 2026";

export default function Legal({ type }) {
  const doc = type === "cookie" ? COOKIE : PRIVACY;
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${doc.title} | Slusariuc Costruzioni`;
  }, [doc]);

  return (
    <main className="min-h-screen bg-[#0d0d0e] text-[#f4f1ea]">
      <header className="border-b border-[#d4a73c]/15 px-6 lg:px-12 py-5 flex justify-between items-center">
        <Link to="/" data-testid="legal-home-link"><Logo /></Link>
        <Link to="/" data-testid="legal-back-link" className="flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-[#e8c063] hover:text-[#f4f1ea]">
          <ArrowLeft size={14} /> Torna al sito
        </Link>
      </header>
      <article data-testid={`legal-${type}`} className="max-w-3xl mx-auto px-6 py-20">
        <p className="label">Informativa · Ultimo aggiornamento {UPDATED}</p>
        <h1 className="mt-4 font-display font-light text-4xl sm:text-5xl lg:text-6xl">{doc.title}</h1>
        <p className="mt-8 text-[#d8d2c6] leading-relaxed">{doc.intro}</p>
        {doc.sections.map(([t, ps]) => (
          <section key={t} className="mt-12">
            <h2 className="font-display text-2xl md:text-3xl text-[#e8c063]">{t}</h2>
            {ps.map((p) => <p key={p.slice(0, 40)} className="mt-4 text-[#d8d2c6] leading-relaxed">{p}</p>)}
          </section>
        ))}
        <p className="mt-14 text-sm text-[#bdb7ab]">
          Vedi anche: {type === "cookie"
            ? <Link to="/privacy-policy" className="text-[#e8c063] underline" data-testid="legal-cross-link">Privacy Policy</Link>
            : <Link to="/cookie-policy" className="text-[#e8c063] underline" data-testid="legal-cross-link">Cookie Policy</Link>}
        </p>
      </article>
      <Footer />
    </main>
  );
}
